import React from 'react'
import { AlertInfo } from '../../../../common/Alert';
import { FaTrash } from "react-icons/fa";
import { AiFillEye } from 'react-icons/ai';
import { NavLink } from 'react-router-dom';
import { formatDateHour, formatCurrency } from "../../../../../utils/Utils";
import { DeleteOrder } from "../requestForm/UseAddOrUpdateOrderForm";
import Skeleton from "react-loading-skeleton";



function ListeCommandeTable({commandes, isLoading}: {commandes: any[], isLoading: boolean}) {

  const getCommandStatusBadge = (statut: string) => {
    switch (statut) {
      case "EN_COURS_DE_TRAITEMENT":
        return <div className="order-status-badge order-status-processing">En cours de traitement</div>;
      case "EN_COURS_DE_LIVRAISON":
        return <div className="order-status-badge order-status-delivery">En cours de Livraison</div>;
      case "LIVRE":
        return <div className="order-status-badge order-status-delivered">Livrée</div>;
      case "ANNULE":
        return <div className="order-status-badge order-status-cancelled">Annulée</div>;
      default:
        return <div className="order-status-badge order-status-processing">En cours de traitement</div>;
    }
  };

  const getPaymentStatusBadge = (isPaid: boolean) => {
    if (isPaid) {
      return <div className="order-status-badge order-status-paid">Payées</div>;
    }
    return <div className="order-status-badge order-status-unpaid">Impayées</div>;
  };

  const formatDate = (date: string) => {
    if (!date) return "";
    // Formater en DD/MM/YYYY
    const dateObj = new Date(date);
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  };

  if (isLoading) {
    return (
      <div className="orders-card-container">
        {Array(4).fill(0).map((_, i) => (
          <div key={i} className="order-card">
            <Skeleton height={120} />
          </div>
        ))}
      </div>
    );
  }

  if (!commandes || commandes.length === 0) {
    return <AlertInfo message="Aucune donnée trouvée" />;
  }

  return (
    <div className="orders-card-container">
      {commandes.map((commande: any) => (
        <div key={commande.id || commande.slug} className="order-card">
          <div className="order-card-content">
            <div className="order-card-row">
              <div className="order-card-col">
                <div className="order-label">N Commande</div>
                <div className="order-value">{commande.code_commande || "N/A"}</div>
              </div>
              <div className="order-card-col">
                <div className="order-label">Date</div>
                <div className="order-value">{formatDate(commande.created_at)}</div>
              </div>
              <div className="order-card-col">
                <div className="order-label">Montant total</div>
                <div className="order-value">
                  {formatCurrency(commande.montant_total || 0, commande.devise || "XOF")}
                </div>
              </div>
              <div className="order-card-col order-status-col">
                <div className="order-label">Statut</div>
                <div className="order-status-badges">
                  {getCommandStatusBadge(commande.statut)}
                  {getPaymentStatusBadge(commande.is_paid)}
                </div>
              </div>
              <div className="order-card-col order-actions-col">
                <div className="order-label">Actions</div>
                <div className="order-actions">
                  <NavLink
                    to={`/mon-compte/commandes/${commande.slug}`}
                    className="order-action-btn order-action-view"
                    title="Voir les détails"
                  >
                    <AiFillEye />
                  </NavLink>
                  <DeleteOrder item={commande} />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ListeCommandeTable

